import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { isNil } from 'lodash'
import RpqsAction from '../../actions/RpqsAction'
import { EVENT_ORIGIN } from './RpqsEventsUtils'

// RPQS d'une EG : uniquement ses événements RPQS.
// RPQS global : événements du RPQS (global + EG) + ceux du référentiel (collectivité + ses EG).
const useRpqsEvents = (year, collectivityId, egId) => {
    const dispatch = useDispatch()
    const [events, setEvents] = useState([])

    const refresh = useCallback(() => {
        const referentialPromise = isNil(egId) ? dispatch(RpqsAction.fetchCollectivityEvents(collectivityId, true)) : Promise.resolve([])
        Promise.all([dispatch(RpqsAction.fetchEvents(year, collectivityId, egId)), referentialPromise])
            .then(([rpqsEvents, referentialEvents]) => setEvents([
                ...(rpqsEvents ?? []).map(e => ({ ...e, origin: EVENT_ORIGIN.RPQS })),
                ...(referentialEvents ?? []).map(e => ({ ...e, origin: EVENT_ORIGIN.REFERENTIAL })),
            ]))
    }, [dispatch, year, collectivityId, egId])

    useEffect(() => {
        refresh()
    }, [refresh])

    return [events, refresh]
}

export default useRpqsEvents
